import { ModeType } from '../enums/ModeType.enum';

export const DEFAULT_MODE_TYPE_NOT_AUTHENTICATED = ModeType.List;
export const DEFAULT_MODE_TYPE_MOBILE = ModeType.List;
export const DEFAULT_MODE_TYPE_DESKTOP = ModeType.List;
